import { render } from "./DSPAccountSideBar.vue?vue&type=template&id=800f7baa&scoped=true"
import script from "./DSPAccountSideBar.vue?vue&type=script&lang=js"
export * from "./DSPAccountSideBar.vue?vue&type=script&lang=js"

import "./DSPAccountSideBar.vue?vue&type=style&index=0&id=800f7baa&scoped=true&lang=scss"
import "./DSPAccountSideBar.vue?vue&type=style&index=1&id=800f7baa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-800f7baa"]])

export default __exports__